import { select } from 'redux-saga/effects';
import { getSelectedBranch } from '../app/selectors';

// eslint-disable-next-line
export function* getBranch() {
  return yield select(getSelectedBranch);
}
